var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_vm._m(0),_c('Homepage'),_c('footer',{staticClass:"footer"},[_c('FooterLinks')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('nav',{staticClass:"nav"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])])])
}]

export { render, staticRenderFns }